export default {
  cancelOrderMap: {
    0: "ฉันไม่ต้องการมัน",
    1: "วางผลิตภัณฑ์ผิดที่",
    2: "คำสั่งซื้อซ้ำ",
    3: "การรับล้มเหลว",
    4: "เหตุผลอื่น ๆ",
  },
  "当前余额": "ยอดคงเหลือปัจจุบัน",
  "请选择": "กรุณาเลือก",
  "备注": "หมายเหตุ",
  "获取验证码": "รหัสผ่าน",
  "验证码": "รหัสผ่าน",
  "请输入验证码": "กรุณากรอกรหัสผ่าน",
  "验证码": "รหัสผ่าน",
  "已发送，请注意查收": "ถูกส่งแล้ว กรุณาตรวจสอบ",
  "仅能绑定一个收款地址!": "สามารถผูกที่อยู่รับเงินได้เพียงหนึ่งที่!",
  "绑定成功": "ผูกสำเร็จ",
  "提款地址绑定": "ผูกที่อยู่ถอน",
  "电商批发商场": "ตลาดผู้ค้าส่งออนไลน์",
  "请输入完整的支付密码!" : "กรุณาใส่รหัสผ่านการชำระเงินทั้งหมด!",
  "用户未发表评论": "ผู้ใช้ไม่ได้แสดงความคิดเห็น",
  "订单": "คำสั่ง",
  "下单成功，等待付款": "สั่งซื้อสำเร็จ รอการชำระเงิน",
  "下单成功，付款成功": "สั่งซื้อสำเร็จ ชำระเงินสำเร็จ",
  "已发货，正在运输中": "จัดส่งในการขนส่ง",
  "订单已取消，原因:手动发起取消订单": "คำสั่งซื้อถูกยกเลิก เหตุผล: ยกเลิกคำสั่งซื้อด้วยตนเอง",
  "订单已取消，原因:超时自动取消订单": "คำสั่งซื้อถูกยกเลิก เหตุผล: คำสั่งซื้อจะถูกยกเลิกโดยอัตโนมัติเมื่อหมดเวลา",
  "商家已确认，已进入备货状态": "ผู้ค้าได้รับการยืนยันและเข้าสู่สถานะสต็อกแล้ว",
  "系统发货成功": "การส่งมอบระบบสำเร็จ",
  "订单已签收": "ได้รับคำสั่งซื้อแล้ว",
  "发起退款申请": "เริ่มการขอคืนเงิน",
  "退款成功": "การคืนเงินสำเร็จ",
  "退款失败": "การคืนเงินล้มเหลว",
  "订单退款成功": "การคืนเงินของคำสั่งซื้อสำเร็จ",
  "订单退款失败": "การคืนเงินคำสั่งซื้อล้มเหลว",
  "系统默认好评": "ระบบตั้งค่าเริ่มต้นเป็นบทวิจารณ์ที่ดี",
  "请输入关键字搜索": "กรุณาใส่คีย์เวิร์ดเพื่อค้นหา",
  "猜你喜欢": "เดาว่าคุณชอบมัน",
  "订单已完成": "การสั่งซื้อเสร็จสมบูรณ์",
  "热销推荐": "คำแนะนำการขายร้อน",
  "头像选择": "การเลือกอวาตาร์",
  "修改头像": "ปรับเปลี่ยนอวาตาร์ของคุณ",
  subOrder: "ส่งคำสั่งซื้อ",
  "mailboxCheck": "กรุณากรอกที่อยู่อีเมลให้ถูกต้อง",
  "switchLang": "โปรดเปลี่ยนไปใช้ภาษาอื่นเพื่อดู",
  "myCart": "รถเข็นของฉัน",
  "notQua": "ไม่ตรงตามเงื่อนไขคุณสมบัติ",
  "noSmaller": "จำนวนเงินที่สมัครต้องไม่ต่ำกว่า",
  "nomax": "จำนวนการสมัครสูงสุดต้องไม่เกิน",
  "evaluationUploading": "คุณยังมีรูปภาพที่กำลังอัปโหลดอยู่ กรุณาลองใหม่อีกครั้งในภายหลัง",
  "evaluateInput": "รีวิวด้วยภาพ",
  "moneyOrderStatus": "สถานะการสั่งซื้อ",
  "coinBlock": "ข้อตกลงสกุลเงิน",
  "dealing": "อยู่ในขั้นตอน",
  "dealSuccess": "ประสบความสำเร็จ",
  "dealFail": "ล้มเหลว",
  "payCertificate": "ใบสำคัญจ่าย",
  "handleFee": "ค่าบริการ",
  "highOpinion": "บทวิจารณ์ที่ดี",
  "mediumOpinion": "รีวิวปานกลาง",
  "lowOpinion": "ความคิดเห็นที่ไม่ดี",
  "hasImage": "ด้วยรูปภาพ",
  "rechargeMethod": "โหมดเติมเงิน",
  "scanAndDown": "สแกน QR Code ดาวน์โหลด APP",
  "receivedAddress": "ที่อยู่ใบเสร็จรับเงิน",
  "ActualLedger": "ใบเสร็จรับเงินจริง",
  "view": "ดู",
  "withdrawNum": "ปริมาณการถอนเงินสด",
  "rechargeNum": "ปริมาณการเติมเงิน",
  "date": "วันที่",
  "walletHistory": "ประวัติกระเป๋าเงิน",
  "accountBalance": "ยอดเงินในบัญชี",
  "accountReview": "ภาพรวมบัญชี",
  "rated": "ตรวจสอบแล้ว",
  "receiver": "เครื่องรับ",
  "orderStatus": "สถานะ",
  "orderTime": "เวลา",
  "tax": "การจัดเก็บภาษี",
  "discount": "การลดราคา",
  "productInfo": "ข้อมูลผลิตภัณฑ์",
  "paramError": "ข้อผิดพลาดของพารามิเตอร์",
  "orderInfo": "ข้อมูลการสั่งซื้อ",
  "rebuy": "อีกหนึ่งออเดอร์",
  "pleaseCorrectAddress": "กรุณากรอกที่อยู่ในการเบิกถอนเงินสดให้ถูกต้อง",
  "pleaseInputCorrectNumber": "กรุณาใส่ตัวเลขที่มากกว่า 0",
  "vcodePass": "ผ่านการตรวจสอบแล้ว!",
  "vcodeFail": "การตรวจสอบสิทธิ์ล้มเหลว โปรดลองอีกครั้ง",
  "uploading": "กำลังอัปโหลด...",
  "uploadSuccess": "อัปโหลดสำเร็จ",
  "uploadError": "การอัพโหลดล้มเหลว. กรุณาลองอีกครั้ง",
  "registerSuccess": "ลงทะเบียนสำเร็จ",
  "pleaseSetMobileNumber": "กรุณาตั้งหมายเลขโทรศัพท์",
  "unSelectedProduct": "คุณยังไม่ได้เลือกผลิตภัณฑ์",
  "loginSuccess": "เข้าสู่ระบบสำเร็จ",
  "pleaseSetAreaCode": "ใส่ชื่อประเทศและรหัสพื้นที่เพื่อค้นหา",
  "login": "เข้าสู่ระบบ",
  "register": "ทะเบียน",
  "logout": "ทางออก",
  "noData": "ไม่พบข้อมูล",
  "search": "ค้นหา",
  "historySearch": "การค้นหาทางประวัติศาสตร์",
  "empty": "ว่างเปล่า",
  "home": "หน้าแรก",
  "favorableRate": "อัตราความคิดเห็นที่ดี",
  "classification": "หมวดหมู่",
  "searchTips": "ค้นหาแหล่งที่มา/สินค้า/ซัพพลายเออร์/คำสั่งซื้อ",
  "dailyNewArrival": "รายการผลิตภัณฑ์ใหม่ทุกวัน",
  "more": "มากกว่า",
  "recommend": "คำแนะนำ",
  "recommendedProducts": "สินค้าแนะนำ",
  "recommendedStore": "ร้านค้าแนะนำ",
  "buyNow": "สั่งซื้อตอนนี้",
  "addCart": "เพิ่มในตะกร้าสินค้า",
  "complex": "แบบบูรณาการ",
  "price": "ราคา",
  "retailPrice": "ราคาขายปลีก",
  "originPrice": "ราคาเดิม",
  "service": "บริการลูกค้า",
  "collect": "รายการโปรด",
  "sold": "ปริมาณการขาย",
  "pageviews": "จำนวนการเรียกดู",
  "quantity": "ปริมาณ",
  "freight": "สินค้า",
  "shipping": "การส่งสินค้า",
  "ship": "เรือ",
  "buyTips": "จัดส่งภายใน 24 ชั่วโมงหลังจากทำการสั่งซื้อ คำสั่งซื้อต่อไปนี้อยู่ภายใต้การควบคุมของลอจิสติกส์และอาจจัดส่งล่าช้า โปรดใส่ใจกับข้อมูลโลจิสติกส์หรือติดต่อฝ่ายบริการลูกค้า",
  "totalPrice": "ราคารวม",
  "addCartMessage": "เพิ่มไปยังตะกร้าสินค้าเรียบร้อยแล้ว",
  "addCartMessageFaild": "สินค้ามีอยู่แล้วในตะกร้าสินค้า",
  "myAccount": "บัญชีของฉัน",
  "buyHistory": "บันทึกการซื้อ",
  "wishlist": "สินค้าที่ชื่นชอบ",
  "trackOrder": "คำสั่ง",
  "account": "บัญชี:",
  "sellerZone": "พื้นที่ค้าขาย",
  "beSeller": "มาเป็นพ่อค้า",
  "sellerPanelLogin": "เข้าสู่ระบบร้านค้า",
  "footTip": "© ลิขสิทธิ์ {name} Ltd 2024",
  "footTips": "{name} Limited ได้รับอนุญาตและควบคุมโดย Financial Conduct Authority ในฐานะนายหน้าสินเชื่อ (713206) และตกลงเฉพาะกับผู้ให้กู้ Home Retail Group CardServices Limited ในฐานะ {name} Financial Services {name} Financial Services ได้รับอนุญาตและควบคุมโดย Financial Conduct Authority เพื่อให้เครดิต (716148) Home Retail GroupCard Services Limited จดทะเบียนในสหราชอาณาจักร (04007072) ที่ Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom MK9 2NW.",
  "item": "บทความ",
  "checkout": "สั่งซื้อสินค้า",
  "productDescription": "รายละเอียดสินค้า",
  "userEvaluation": "ความคิดเห็นของผู้ใช้",
  "AllProducts": "สินค้าทั้งหมด",
  "followers": "ติดตาม",
  "sales": "ปริมาณการขาย",
  "visitStore": "เยี่ยมชมร้านค้า",
  "authentic": "ของแท้ 100%",
  "dayReturns7": "7 วันกลับ",
  "shippingDiscounts": "ส่วนลดค่าขนส่ง",
  "safePayment": "การชำระเงินที่ปลอดภัย",
  "followed": "ตามมา",
  "dashboard": "แผงเครื่องมือ",
  "myOrder": "คำสั่งของฉัน",
  "setUp": "ติดตั้ง",
  "successTips": "ประสบความสำเร็จ",
  "copySuccess": "การจำลองแบบสำเร็จ",
  "balance": "ยอดคงเหลือ (USDT)",
  "sort": "พิมพ์",
  "commodity": "ผลิตภัณฑ์",
  "browse": "ปริมาณการขาย",
  "recharge": "เติมเงิน",
  "commodityCollection": "การรวบรวมผลิตภัณฑ์",
  "withdraw": "ถอนเงินสด",
  "defaultAddress": "ที่อยู่เริ่มต้น",
  "addNewAddress": "เพิ่มที่อยู่ใหม่",
  "withdrawRecord": "บันทึกการถอนเงินสด",
  "serialNumber": "เลขที่ใบสั่งซื้อ",
  "time": "เวลา",
  "amount": "จำนวน",
  "processing": "อยู่ในขั้นตอน",
  "fail": "ล้มเหลว",
  "blockchainNetwork": "เครือข่ายบล็อกเชน",
  "records": "บันทึก",
  "withdrawAddress": "ที่อยู่ถอนเงินสด",
  "withdrawInputTips": "กรุณากรอกที่อยู่ในการถอนเงิน",
  "copy": "การจำลองแบบ",
  "enterTips": "กรุณาป้อน",
  "actualAccount": "บัญชีจริง",
  "handlingFee": "ค่าบริการ",
  "confirm": "ยืนยันการรับสินค้า",
  "previous": "ขั้นตอนก่อนหน้า",
  "pleaseEnterAddress": "กรุณากรอกที่อยู่",
  "pleaseEnterQuantity": "กรุณาใส่จำนวน",
  "withdrawSuccess": "ส่งคำสั่งซื้อสำเร็จแล้ว",
  "saveQr": "บันทึกคิวอาร์โค้ด",
  "pleaseEnterAmount": "กรุณากรอกจำนวนเงินที่เติม",
  "expectedArrival": "การมาถึงที่คาดว่าจะมาถึง",
  "currentRate": "อัตราแลกเปลี่ยนปัจจุบัน",
  "uploadTips": "หลักฐานการชำระเงิน (อัพโหลดภาพหน้าจอรายละเอียดการชำระเงิน)",
  "clickUpload": "คลิกเพื่ออัปโหลด",
  "uploadPhoto": "กรุณาอัปโหลดรูปถ่าย",
  "rechargeSuccessful": "เติมเงินสำเร็จ",
  "rechargeTips": "\"การแจ้งการเติมเงิน: \"\"กรุณากรอกจำนวนเงินที่โอนจริงตามความเป็นจริง มิฉะนั้น ระบบอาจไม่ผ่านการอนุมัติและส่งผลต่อความคืบหน้าในการเติมเงิน\"",
  "rechargeRecord": "บันทึกการเติมเงิน",
  "all": "ทั้งหมด",
  "pending": "ที่จะต้องจ่าย",
  "cancelled": "ยกเลิก",
  "delivered": "ที่จะจัดส่ง",
  "confirmed": "ยืนยัน",
  "receipt": "ที่จะได้รับ",
  "harvested": "ได้รับ",
  "comment": "ที่จะได้รับการตรวจสอบ",
  "refund": "การคืนเงิน/หลังการขาย",
  "cancelOrder": "ยกเลิกคำสั่งซื้อ",
  "cancelReason": "เหตุผลในการยกเลิก",
  "cancelOrderTitle": "โปรดเลือกเหตุผลในการยกเลิกคำสั่งซื้อ",
  "returnOrderTitle": "โปรดเลือกเหตุผลในการคืนสินค้า",
  "refundInstructions": "คำแนะนำในการคืนเงิน",
  "returnDetailTips": "กรุณาให้ความคิดเห็นเกี่ยวกับผลิตภัณฑ์",
  "cancel": "ยกเลิกคำสั่งซื้อ",
  "cancelOrder1": "ไม่ได้รับสินค้า",
  "cancelOrder2": "ไม่ชอบก็ไม่อยากได้",
  "cancelOrder3": "ผู้ขายส่งสินค้าผิด",
  "cancelOrder4": "ยี่ห้อปลอม",
  "cancelOrder5": "ส่งน้อย พลาดส่ง",
  "cancelOrder6": "ได้รับสินค้าเสียหาย",
  "cancelOrder7": "มีปัญหาด้านคุณภาพ",
  "cancelOrder8": "เจรจาคืนเงินกับผู้ขาย",
  "cancelOrder9": "เหตุผลอื่น ๆ",
  "cancelOrderSuccess": "ยกเลิกคำสั่งซื้อเรียบร้อยแล้ว",
  "returnOrderSuccess": "ส่งสำเร็จ",
  "orderName": "ชื่อ",
  "orderEmail": "อีเมล",
  "orderAddress": "ที่อยู่",
  "orderNation": "ประเทศ",
  "orderState": "สถานะ",
  "orderCity": "เมือง",
  "orderPostCode": "รหัสไปรษณีย์",
  "orderAmount": "ปริมาณ",
  "orderPrefix": "ยอดสั่งซื้อ",
  "orderFee": "ภาษี",
  "orderSpecification": "ข้อมูลจำเพาะ",
  "orderCommodity": "ผลิตภัณฑ์",
  "orderQuantity": "ปริมาณ",
  "orderUnitprice": "ราคาต่อหน่วย",
  "orderFreight": "สินค้า",
  "orderTax": "ภาษี",
  "orderTotal": "ทั้งหมด",
  "PaymentOrder": "สั่งจ่าย",
  "Evaluate": "ทบทวน",
  "CancelOrder": "ยกเลิกคำสั่งซื้อ",
  "RemindShip": "เตือนสำหรับการจัดส่ง",
  "Refund": "คืนเงิน",
  "Submitareview": "ส่งความคิดเห็น",
  "Information": "ข้อมูล",
  "wrongPassword": "รหัสผ่านผิดพลาดมากกว่า 3 ครั้ง โปรดลองอีกครั้งในวันพรุ่งนี้",
  "Operate": "การดำเนินการ",
  "Item": "รายการ",
  "From": "จาก",
  "hint": "เคล็ดลับ",
  "CheckDetails": "ดูรายละเอียด",
  "Payment": "การชำระเงิน",
  "Cancel": "ยกเลิก",
  "refundSuccessfully": "การคืนเงินสำเร็จ",
  "pendingPayment": "ที่จะต้องจ่าย",
  "pay": "การชำระเงิน",
  "LoginPassword": "รหัสผ่านการเข้าใช้งาน",
  "sure": "แน่นอน",
  "shippingAddress": "ที่อยู่รับ",
  "pleaseAddShippingAddress": "กรุณาเพิ่มที่อยู่จัดส่งก่อน",
  "transactionPassword": "รหัสผ่านการทำธุรกรรม",
  "markDefaultAddress": "ทำเครื่องหมายเป็นที่อยู่จัดส่งเริ่มต้น",
  "edit": "แก้ไขโดย",
  "delete": "ลบ",
  "Opt": "เลือก",
  "piece": "ชิ้น",
  "orderDetails": "รายละเอียดการสั่งซื้อ",
  "shopCollection": "เพิ่มร้านค้าในรายการโปรด",
  "addAddress": "เพิ่มที่อยู่ใหม่",
  "signUp": "ทะเบียน",
  "loginTips": "มีบัญชีอยู่แล้ว?",
  "loginIn": "เข้าสู่ระบบ",
  "mobile": "หมายเลขโทรศัพท์",
  '购物车还没有商品': 'ไม่มีสินค้าในรถเข็น',
  '去购物': 'ไปช็อปปิ้ง',
  "modifyAddress": "แก้ไขที่อยู่",
  "desc": "ตั้งเป็นที่อยู่เริ่มต้น",
  "keep": "บำรุงรักษา",
  "onlineService": "บริการออนไลน์",
  "send": "ส่ง",
  "EsShop": "ร้านค้าออนไลน์",
  "desc3": "ป้อนรหัสผ่านการทำธุรกรรม",
  "desc4": "ป้อนรหัสผ่านการทำธุรกรรมของคุณ",
  "desc6": "ป้อนรหัสผ่านการทำธุรกรรมของคุณอีกครั้ง",
  "setUpPayPaw": "ตั้งรหัสผ่านการทำธุรกรรม",
  "setSuccess": "ตั้งค่าสำเร็จ",
  "confirmPayPaw": "ยืนยันรหัสผ่านการทำธุรกรรม",
  "paymentSuccessful": "ชำระเงินสำเร็จ",
  "paymentPending": "รอการชำระเงิน",
  "paymentPendingDesc": "การชำระเงินของคุณกำลังดำเนินการ โปรดตรวจสอบสถานะคำสั่งซื้อของคุณในภายหลัง",
  "desc5": "ที่อยู่จัดส่งผิด? ติดต่อ",
  "customeService": "บริการลูกค้าออนไลน์",
  "BackHome": "กลับไปที่หน้าแรก",
  "Checkorder": "ดูคำสั่งซื้อ",
  "ForgotPassword": "ลืมรหัสผ่าน?",
  "signIn": "เข้าสู่ระบบ",
  "noAccount": "ไม่มีเลขที่บัญชี?",
  "pleaseEnterAccount": "กรุณากรอกเลขที่บัญชี",
  "pleaseEnterPassword": "กรุณาใส่รหัสผ่าน",
  "password": "รหัสผ่าน",
  "mobilePhone": "หมายเลขโทรศัพท์",
  "pleaseEnterPhoneNumer": "กรุณาตั้งหมายเลขโทรศัพท์",
  "setPassword": "ตั้งรหัสผ่าน",
  "noDataFound": "ไม่พบข้อมูล",
  "searchCountry": "ใส่ชื่อประเทศและรหัสพื้นที่เพื่อค้นหา",
  "pleaseEnterEmail": "กรุณาตั้งค่ากล่องจดหมาย",
  "invitationCode": "รหัสการเชิญ",
  "plaeseEnterInvitaionCode": "กรุณาตั้งรหัสเชิญ",
  "pleaseSetLoginPassword": "กรุณาตั้งรหัสผ่านเข้าสู่ระบบ",
  "selectDeliveryAddress": "เลือกที่อยู่ในการจัดส่ง",
  "totalOf": "ทั้งหมด",
  "items": "รายการ",
  "orderSummary": "สรุปการสั่งซื้อ",
  "paymentMethod": "วิธีการชำระเงิน",
  "Balance": "สมดุล",
  "payPal": "เพย์พาล",
  "notOpen": "วิธีการชำระเงินนี้ยังไม่เปิดในภูมิภาคของคุณ",
  "mastercard": "มาสเตอร์การ์ด",
  "additional": "พิเศษ",
  "handlingfee": "ต้องเสียค่าบริการ",
  "goodsNumber": "ปริมาณสินค้า",
  "deliveryFee": "ค่าขนส่ง",
  "totalNum": "ทั้งหมด",
  "new": "ใหม่",
  "oldPassword": "รหัสผ่านเก่า",
  "pleaseEnterOldPassword": "กรุณากรอกรหัสผ่านเดิม",
  "newPassword": "รหัสผ่านใหม่",
  "plaseeEnterNewPassword": "กรุณาใส่รหัสผ่านใหม่",
  "confirmPassword": "ยืนยันรหัสผ่าน",
  "plaseeENterConfirmPassword": "กรุณากรอกรหัสผ่านยืนยัน",
  "twoPawword": "รหัสผ่านสองตัวไม่เหมือนกัน",
  "rechargeAddress": "ที่อยู่เติมเงิน",
  "plaseEnterRechargeAddress": "กรุณากรอกที่อยู่สำหรับเติมเงิน",
  "userCenter": "ศูนย์ส่วนบุคคล",
  "merchantSettled": "รายการร้านค้า",
  "upNew": "รายการผลิตภัณฑ์ใหม่",
  "balanceNot": "ยอดเงินไม่เพียงพอ กรุณาเติมเงิน",
  "NoProductSelected": "สินค้ายังไม่ได้เลือก",
  "ShippingAddressNotSet": "ไม่ได้ตั้งค่าที่อยู่ในการจัดส่ง",
  "consigneeName": "ชื่อผู้รับ",
  "email": "อีเมล:",
  "areaCode": "รหัสพื้นที่ระหว่างประเทศ",
  "phoneNumber": "หมายเลขโทรศัพท์",
  "nation": "ประเทศ",
  "state": "จังหวัด/รัฐ/รัฐ",
  "city": "เมือง",
  "postCode": "รหัสไปรษณีย์",
  "address": "ที่อยู่โดยละเอียด",
  "addAddressOrModifyAddress": "เพิ่มที่อยู่ใหม่/แก้ไขที่อยู่",
  "setAsTheDefaultAddress": "ตั้งเป็นที่อยู่เริ่มต้น",
  "proceed": "ดำเนินการต่อ",
  "btnSure": "ยืนยัน",
  "pleaseInput": "กรุณาป้อน",
  "allProduct": "สินค้าทั้งหมด",
  "myCommodityCollection": "สินค้าที่ชื่นชอบ",
  "myFollowedShops": "ติดตามร้านค้า",
  "mySold": "ขายแล้ว",
  "myPageviews": "จำนวนการเรียกดู",
  "myPraiseRate": "อัตราความคิดเห็นที่ดี",
  "myUnfollow": "เลิกติดตาม",
  "inputNum": "ตัวเลข",
  "inpuEmailErro": "กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง",
  "goodsShip": "การจัดส่ง",
  "goodsShipTips": "สินค้าจะถูกจัดส่งภายใน 24 ชั่วโมงหลังจากทำการสั่งซื้อ หากมีการควบคุมลอจิสติกส์สำหรับคำสั่งซื้อต่อไปนี้ คำสั่งซื้ออาจล่าช้า โปรดใส่ใจกับข้อมูลโลจิสติกของคำสั่งซื้อหรือติดต่อฝ่ายบริการลูกค้า",
  "goodsFreight": "ค่าขนส่ง",
  "goodsFreeShipping": "ไม่คิดเงิน",
  "goodsFreightTips1": "1. องค์ประกอบการขนส่งสินค้าข้ามพรมแดน: ค่าขนส่ง = ค่าธรรมเนียมการจัดส่ง + ค่าขนส่งทางไกล + ค่าธรรมเนียมการจัดส่ง",
  "goodsFreightTips2": "2. หากไม่ตรงตามเงื่อนไขของไปรษณีย์ จะคิดค่าขนส่งตามเงื่อนไขจริง",
  "goodsFreightTips3": "3. สิทธิ์ในการตีความขั้นสุดท้ายเป็นของแพลตฟอร์ม",
  "pleaseValidPostCode": "กรุณาใส่ตัวเลขมากกว่า 4 หลัก",
  "pleaseValidEmail": "กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง",
  "pleaseValidPhone": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
  "productAvailable": "ผลิตภัณฑ์นี้ถูกลบออกแล้ว",
  "validatorMaxNumber": "จำนวนเงินเกินขีดจำกัด",
  "validatorRequire": "รายการที่จำเป็นต้องไม่เป็นโมฆะ",
  "validatorPhone": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
  "validatorEmail": "โปรดป้อนรูปแบบอีเมลที่ถูกต้อง",
  "validatorPassword": "รหัสผ่านประกอบด้วย 6-12 หลักหรือตัวอักษร(มีอักขระพิเศษ)",
  "validatorSixNumber": "กรุณาใส่ตัวเลข 6 หลัก",
  "validatorFourMoreNumber": "กรุณาใส่ตัวเลขหรือตัวอักษรรวมกัน 4-32 ตัว",
  "validatorIpRule": "รูปแบบ IP ไม่ถูกต้อง",
  "validatorChineseAndEnglish": "ภาษาจีนและภาษาอังกฤษเท่านั้น ช่วงการป้อน: 8-64 ตัวอักษร",
  "collectionSuccess": "เพิ่มในรายการโปรดสำเร็จ",
  "followedSuccess": "ติดตามสำเร็จ",
  "加值": "เพิ่มค่า",
  "平台人工发起退款": "เงินคืนที่เกิดจากการดำเนินการของผู้ขาย",
  "银行卡": "บัตรธนาคาร",
  "提领": "ถอน",
  "联系商家": "ติดต่อผู้ขาย",
  "cancelSuccess": "ยกเลิกสำเร็จ",
  "evaluateOrder": "รีวิวด้วยภาพ",
  "evaluateOrderPlaceholder": "กรุณาตรวจทานสินค้า",
  "operationSuccess": "การดำเนินการสำเร็จ",
  "confirmReceiveGoods": "ยืนยันการรับสินค้าหรือไม่",
  "evaluateOrderSuccess": "ตรวจสอบสำเร็จ",
  "yesterday": "เมื่อวาน",
  "notLogin": "คุณยังไม่ได้เข้าสู่ระบบ",
  "delAllHistoryRecord": "คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกประวัติทั้งหมด",
  "or": "หรือ",
  "tipsRemindsText": "ผู้ค้าจะได้รับการแจ้งเตือนหลังจากเตือนการจัดส่งแล้ว",
  "tipsRemindsCount": "สามารถเตือนได้เพียงครั้งเดียวเท่านั้น",
  "tipsRemindsMerchant": "เตือนพ่อค้า",
  "tipsRemindsSuccess": "การแจ้งเตือนสำเร็จ",
  "noCartTips": "กระเป๋าช้อปปิ้งของคุณว่างเปล่า. เริ่มช้อปปิ้ง",
  "defaultRate": "ระบบตั้งค่าเริ่มต้นเป็นบทวิจารณ์ที่ดี",
  "prevPage": "หน้าก่อนหน้า",
  "nextPage": "หน้าต่อไป",
  "returnApply": "คำขอคืนเงิน",
  "returnReason": "เหตุผลในการคืนเงิน",
  "returnAmount": "คืนจำนวนเงิน",
  "returnRemark": "ส่งคืนคำแนะนำ",
  order: {
    cancel: "ยกเลิกคำสั่งซื้อ",
    payment: "จ่ายตอนนี้",
    remind: "เตือนสำหรับการจัดส่ง",
    return: "ขอคืนค่าสินค้า",
    evaluate: "รีวิวเลย",
    logistics: "ดูงานด้านโลจิสติกส์",
    noRefund: "ไม่คืนเงิน",
    refunding: "กำลังดำเนินการคืนเงิน",
    refundSuccess: "การคืนเงินสำเร็จ",
    refundFail: "การคืนเงินล้มเหลว",
    confirm: "ยืนยันการรับสินค้า",
  },
  "remindTitle": "เตือนสำหรับการจัดส่ง",
  "remindContent": "หลังจากที่มีการเตือนการจัดส่ง ผู้ค้าจะได้รับการเตือน สามารถเตือนได้เพียงครั้งเดียวเท่านั้น",
  "remindSuccess": "การแจ้งเตือนสำเร็จ",
  "remindRepeat": "คำสั่งนี้ได้รับการเตือนแล้ว",
  "noComments": "ไม่มีการตรวจสอบในขณะนี้",
  "storeSeach": "ค้นหาสินค้าในร้านค้านี้",
  "storeSeachTips1": "พบสำหรับคุณ",
  "storeSeachTips2": "พบร้านค้าที่เกี่ยวข้อง",
  "storeSeachTips3": "บ้าน",
  "creditTit": "บริการสินเชื่อ",
  "getCoupons": "รับคูปองเพิ่มเติม",
  "yourEmail": "ที่อยู่อีเมลของคุณ",
  "subscription": "การสมัครรับข้อมูล",
  "paymethods": "วิธีการชำระเงิน",
  "footdec": "ผู้ใช้ไซต์ทั่วโลกของ {name} มาจาก {num} ประเทศทั่วโลกและใช้ {coin} ในการชำระเงิน {coin} เป็นธุรกรรมแบบไร้พรมแดนที่ช่วยให้ทำธุรกรรมได้ทันทีและต้นทุนต่ำทั่วโลกโดยไม่ต้องรอและเสียค่าธรรมเนียมระหว่างประเทศ",
  "custService": "บริการลูกค้า",
  "helpLine": "บริการลูกค้าออนไลน์",
  "contactUs": "ติดต่อเรา",
  "客户端下载": "ดาวน์โหลด",
  "提现方式":"วิธีการถอนเงิน",
  "partner": "ซัพพลายเออร์สหกรณ์",
  "buyRules": "กฎของผู้ซื้อ",
  "sellerRules": "นโยบายของผู้ขาย",
  "returnsAndEx": "ผลตอบแทนและการแลกเปลี่ยน",
  "servicePolicy": "นโยบายการบริการ",
  "returnPolicy": "นโยบายการคืนสินค้า",
  "user_Center": "ศูนย์ผู้ใช้",
  "userReg": "การลงทะเบียนผู้ใช้",
  "orderTrack": "สอบถามสั่งซื้อ",
  "purchageHistory": "ประวัติการซื้อ",
  "myPurse": "กระเป๋าเงินของฉัน",
  "aboutUs": "เกี่ยวกับเรา",
  "Recruitment": "รอคนเก่ง",
  "news": "ข้อมูลข่าวสาร",
  "stateMent": "แถลงการณ์เรื่องทาสสมัยใหม่",
  "binance": "บินานซ์",
  "huobi": "หั่วปี้",
  "okx": "ตกลง",
  "metaMask": "MetaMask",
  "homeBannertips1": "มาเป็นพ่อค้า",
  "homeBannertips2": "ค่าคอมมิชชั่นทั้งหมด",
  "homeBannertips3": "สูงสุด",
  "homeBannerbtn": "เข้าร่วมเดี๋ยวนี้",
  "homeDownloadtips1": "ห้างสรรพสินค้าค้าส่งอีคอมเมิร์ซข้ามพรมแดน",
  "homeDownloadtips2": "ข้อเสนอพิเศษของแบรนด์",
  "homeDownloadtips3": "ลดไม่หยุด",
  "homeDownloadtips4": "ดาวน์โหลดแอนดรอยด์",
  "homeDownloadtips5": "ดาวน์โหลดแอปเปิ้ล",
  "homeDownloadtips6": "สแกนรหัส QR เพื่อดาวน์โหลด APP",
  "homeIconTips1": "ของแท้ 100%",
  "homeIconTips2": "7 วันกลับ",
  "homeIconTips3": "ส่วนลดค่าขนส่ง",
  "homeIconTips4": "การชำระเงินที่ปลอดภัย",
  "headerSearchTips": "กรุณาใส่คีย์เวิร์ดเพื่อค้นหา",
  "collAccount": "โหมดเงินกู้",
  "mine": "ของฉัน.",
  "creditText1": "สินเชื่อเริ่มต้นช่วยแก้ปัญหาการกู้ยืมเงิน",
  "creditText2": "ให้บริการสินเชื่อเริ่มต้นและหมุนเวียนเงินทุน",
  "creditWorry": "เงินกู้ไร้กังวล",
  "creditQuota": "ขีดจำกัดที่ยืดหยุ่น",
  "creditQuotaINFO": "100,000 ถึง 30,000,000 ด้วยวงเงินที่ยืดหยุ่นและไม่มีข้อ จำกัด โดยมีระยะเวลากู้สูงสุดหนึ่งปี",
  "quickLoan": "เงินกู้ด่วน",
  "creditReview": "ผ่านการตรวจสอบอย่างเร็วที่สุดหนึ่งชั่วโมง หากการตรวจสอบผ่าน สินเชื่อจะถูกปล่อยทันที",
  "safe": "ปลอดภัยไร้กังวล",
  "safeInfo": "ไม่มีการจดจำนอง ไม่มีการฝาก ไม่มีการเรียกกลับ เพราะนี่เป็นเรื่องส่วนตัว",
  "about": "เกี่ยวกับเรา",
  "aboutText1": "\"เรามุ่งมั่นที่จะให้บริการทางการเงินสินเชื่อตามปรัชญาการดำเนินธุรกิจ \"\"ลูกค้ารายแรก\"\" มีภารกิจในการแก้ปัญหาการหมุนเวียนเงินทุนของลูกค้า นับตั้งแต่ก่อตั้ง บริษัทได้ช่วยเหลือลูกค้าจำนวนมากในการแก้ปัญหาการหมุนเวียนของเงินทุน\"",
  "aboutText2": "วงเงิน: 100,000-30,000,000, วิธีการชำระคืนที่ยืดหยุ่นพร้อมดอกเบี้ยต่ำ, ไม่มีค่าธรรมเนียมล่วงหน้า, เงินกู้ออนไลน์, ไม่ต้องโทรศัพท์เพื่อตรวจสอบ, ข้อมูลที่เป็นความลับและให้ยืมในวันเดียวกัน",
  "contactUs1": "หากคุณไม่ต้องการยืมเงินจากเพื่อนร่วมระดับของคุณ โปรดติดต่อเรา",
  "committed": "มุ่งมั่นที่จะให้บริการสินเชื่อผู้ประกอบการ",
  "financial": "จัดการกับข้อกังวลทางการเงินของคุณ",
  "partnersTit": "แพลตฟอร์มให้ยืมพันธมิตรออนไลน์",
  "application": "การสมัครสินเชื่อ",
  "applicant": "ผู้สมัคร",
  "actualName": "ชื่อจริง",
  "yourName": "กรุณากรอกชื่อ",
  "term": "ระยะเวลาการกู้ยืม",
  "applicationAmount": "จำนวนเงินที่ขอ",
  "rates": "อัตราดอกเบี้ยเงินกู้",
  "loanMethod": "โหมดเงินกู้",
  "accountB": "ยอดเงินในบัญชี",
  "countryOf": "สัญชาติ",
  "myloan": "เงินกู้ของฉัน",
  "applyLoan": "สมัครสินเชื่อ",
  "loaned": "ยืมตัว",
  "interest": "ดอกเบี้ยค้างรับ",
  "esRepayment": "การชำระคืนโดยประมาณ",
  "loanHistory": "บันทึกการกู้ยืม",
  "applicantDate": "วันรับสมัคร",
  "repayment": "การชำระคืน",
  "cycle": "รอบการชำระคืน",
  "fixedRate": "อัตราดอกเบี้ยคงที่",
  "successLoan": "สินเชื่อสำเร็จ",
  "Reapply": "สมัครใหม่",
  "borrow": "สินเชื่อล้มเหลว",
  "applicantIn": "กำลังดำเนินการสมัคร",
  "repaid": "การชำระคืน",
  "overdue": "ค้างชำระ",
  "estirepay": "การชำระคืนโดยประมาณ",
  "loanDays": "จำนวนวันที่ยืม",
  "reAmount": "จำนวนเงินที่ชำระคืน",
  "repay": "โหมดการชำระคืน",
  "entRepay": "ยืนยันการชำระคืน",
  "foryourmoney": "หากคุณกำลังขาดแคลนทุนทรัพย์ หาแหล่งยืมเงินไม่ได้ หรืออายที่จะยืมเงินเพื่อน ติดต่อเราได้ เรามีบริการอย่างมืออาชีพครบวงจรเพื่อตอบข้อสงสัยของคุณได้ตลอดเวลา เป้าหมายของเราคือการทำให้แต่ละสินเชื่อมีความโปร่งใสเพื่อให้ลูกค้าสามารถใช้งานได้อย่างรวดเร็วและมั่นใจ",
  "onlineApplin": "สมัครออนไลน์",
  "businessloan": "การสมัครขอสินเชื่อเริ่มต้น",
  "selectCountry": "กรุณาเลือกสัญชาติ",
  "selectPeriod": "กรุณาเลือกช่วงเวลา",
  "passPortImg": "เลขประจำตัวประชาชน/เลขที่หนังสือเดินทาง",
  "uploadId": "อัปโหลดรูปถ่ายใบรับรอง / หนังสือเดินทาง",
  "readAndAgree": "ฉันได้อ่านและเห็นด้วย",
  "loanAgree": "สัญญาเงินกู้",
  "submitApplica": "การส่งใบสมัคร",
  "photoExample": "ตัวอย่างการถ่ายภาพ",
  "discounted": "สินค้าลดราคา",
  "days": "วัน",
  "privacyPolicy": "นโยบายความเป็นส่วนตัว",
  "delivery": "จัดส่งและรับของ",
  "checkAgreement": "กรุณาทำเครื่องหมายข้อตกลง!",
  "businessPhone": "เบอร์โทรสำหรับติดต่อเรื่องธุรกิจ",
  "businessEmail": "อีเมลองค์กร",
  "提交失败": "การส่งล้มเหลว",
  "充值金额不能小于1": "จำนวนการเติมเงินต้องไม่ต่ำกว่า 1 (รวมทศนิยม 2 ตำแหน่ง)",
  "请切换其他语言后查看": "โปรดเปลี่ยนไปใช้ภาษาอื่นเพื่อดู",
  "我的购物车": "รถเข็นของฉัน",
  "推荐商品": "สินค้าแนะนำ",
  "猜你喜欢": "เดาว่าคุณชอบมัน",
  "暂无店铺": "ไม่พบร้านค้า",
  "添加失败": "ส่งไม่สำเร็จ กรุณาลองใหม่อีกครั้งในภายหลัง",
  "提交订单": "การส่งคำสั่งซื้อ",
  recommendclass: "แนะนำหมวดหมู่",
  "滑动验证": "การตรวจสอบการเลื่อน",
  "最多上传9张图片": "อัปโหลดรูปภาพได้สูงสุด 9 ภาพ",
  "账号注销": "ยกเลิกบัญชี",
  "确定注销": "ยืนยันการยกเลิก",
  "您的账号": "บัญชีของคุณ",
  "为什么要离开": "ทำไมต้องออก",
  "您还有余额,不能注销账号": "คุณยังมีเงินคงเหลือ ไม่สามารถยกเลิกบัญชีได้",
  "长时间未付款，系统自动取消订单": "ยกเลิกคำสั่งซื้อโดยระบบเนื่องจากไม่ได้ชำระเงินเป็นเวลานาน",
  "请输入注销理由": "โปรดป้อนเหตุผลในการยกเลิก",
  "您确认要注销吗?": "คุณยืนยันที่จะยกเลิกหรือไม่?",
  "我再考虑下": "ฉันกำลังพิจารณาอีกครั้ง",
  "同意注销": "ยอมรับการยกเลิก",
  "注销成功": "ยกเลิกสำเร็จ",
  "App下载(买家端)": "ดาวน์โหลดแอป (ซื้อขาย)",
  "App下载(卖家端)": "ดาวน์โหลดแอป (ขาย)",
  "最多包含10位小数": "สูงสุด 10 ตำแหน่งทศนิยม",
  "企业电话": "โทรศัพท์ธุรกิจ",
  "加密货币": "สกุลเงินที่เข้ารหัส",
  "职业机会": "โปรโมชั่น",
  "银行卡": "บัตรธนาคาร",
  '参数缺失': 'ขาดพารามิเตอร์',
  '充值数量必填': 'จำนวนการเติมเงินจำเป็น',
  "充值币种": "เติมเงินสกุลเงิน",
  "充值金额": "จำนวนเงินที่เติม",
  "充值金额不得小于": "จำนวนเงินที่เติมต้องไม่น้อยกว่า",
  "充值金额不得大于": "จำนวนเงินที่เติมต้องไม่มากกว่า",
  "请先选择币种": "โปรดเลือกสกุลเงินก่อน",
  "开户行": "ธนาคารที่เปิดบัญชี",
  "请输入开户行名称": "โปรดป้อนชื่อธนาคารที่เปิดบัญชี",
  "银行卡号": "หมายเลขบัตรธนาคาร",
  "请输入银行卡号": "โปรดป้อนหมายเลขบัตรธนาคาร",
  "点击去支付": "คลิกเพื่อชำระเงิน",
  "企业证明": "หลักฐานองค์กร",
  footTipTikTok:'ติ๊กต๊อกมอลล์ ©️2024 ลิขสิทธิ์',
  TikTokFoot:'CoveBuy Mall เป็นแพลตฟอร์มโซเชียลวิดีโอสั้นระดับโลกอย่าง CoveBuy และบริษัทการค้าส่งรายใหญ่ที่สุดในเอเชียอย่าง Alibaba ซึ่งก่อตั้งขึ้นโดยความร่วมมือ เป็นแพลตฟอร์มอีคอมเมิร์ซระดับโลกและมีคลังสินค้าอัจฉริยะที่ดำเนินการด้วยตนเองสามแห่งในโลก ตั้งอยู่ในโตรอนโต แคนาดา ลอสแองเจลิส และชิบะ ประเทศญี่ปุ่น สินค้าที่จำหน่ายในแอปประกอบด้วยสินค้ายอดนิยมจากญี่ปุ่น เกาหลีใต้ จีน และประเทศอื่นๆ ในเอเชีย ปัจจุบันมีจำนวนมากกว่า 50,000 รายและยังคงเติบโตอย่างรวดเร็ว',
  "cancelInfo":"เตือน! โปรดระวังการยกเลิกบัญชี หากคุณไม่ได้ใช้บัญชีอีกต่อไป คุณสามารถคลิก [ตกลงที่จะยกเลิก] คุณอาจไม่สามารถลงทะเบียนได้ภายในสองสามวันหลังจากการยกเลิก",
  "betaBannerText": "เว็บไซต์อยู่ระหว่างการทดสอบสาธารณะ กรุณาอย่าสั่งซื้อสินค้า"
}